<div class="container">
  <amp-tag-value-item #ampTag [tag]="tag" [isDeletable]="false" (changed)="handleChange($event)"></amp-tag-value-item>
  <avn-button
    [disabled]="ampTag?.internalFormControl?.invalid || ampTag?.internalFormControl?.pristine"
    class="container__button-apply"
    [label]="'tagOperation.TAG_OPERATION.TAG_DETAIL.ACTIONS.APPLY_30' | transloco"
    (actioned)="applyChanges()"
  ></avn-button>
</div>
